module.exports = __webpack_public_path__ + "img/balenoForm.47ac5b70.svg";